import React, { useEffect, useState } from 'react'
import DateInput from '../DateInput/DateInput';
import InputDropDown from '../InputDropDown/InputDropDown';
import { concatenateDateTime, getTimeSlots } from '../../helpers/HelperFunctions';
import moment from 'moment';

import './SelectTime.scss'

type SelectTimeProps = {
    formData: any,
    setFormData: CallableFunction,
}

function SelectTime(props: SelectTimeProps) {

    const [timeSlots, setTimeSlots] = useState([] as string[]);

    useEffect(() => {
        getTimeSlots(setTimeSlots);
    }, [])

    const getTimeUpToNow = () => {
        let timeRange = [] as { label: string; value: any; }[]

        if (props.formData.date.isSame(new Date(), 'day')) {
            timeSlots.forEach(time => {
                if (moment(time).isAfter(props.formData.date) || moment(time).isSame(props.formData.date)) {
                    timeRange.push({ label: moment(time).format('hh:mm a'), value: time })
                }
            });
        } else if (props.formData.date.isAfter(new Date(), 'day')) {

            timeSlots.forEach(time => {
                timeRange.push({ label: moment(time).format('hh:mm a'), value: time })
            });
        }

        return timeRange;
    }

    const getEndTime = () => {
        let timeRange = [] as { label: string; value: any; }[]
        if (props.formData.date.isSame(new Date(), 'day')) {
            timeSlots.forEach(time => {
                if (moment(time).isAfter(concatenateDateTime({ date: Date(), time: props.formData.startTime.toString() }))) {
                    timeRange.push({ label: moment(time).format('hh:mm a'), value: time })
                }
            });
        } else if (props.formData.date.isAfter(new Date(), 'day'))
            timeSlots.forEach(time => {
                if (moment(time).isAfter(concatenateDateTime({ date: Date(), time: props.formData.startTime.toString() }))) {
                    timeRange.push({ label: moment(time).format('hh:mm a'), value: time })
                }
            });

        return timeRange;
    }

    return (
        <div className='select-time-container'>
            <div className="input-field">
                <DateInput label={"Date"} value={props.formData.date.toDate().toISOString()} showError={false}
                    onChange={(date: any) => {
                        if (date) {
                            let form = props.formData;
                            form.date = date;
                            form.startTime = moment();
                            form.endTime = moment();
                            props.setFormData((previousData: any) => ({ ...previousData, ...form }));
                        }
                    }} />
            </div>
            <div className="input-field">
                <InputDropDown defaultValue={props.formData.startTime.format('hh:mm a')} title={"Start Time"}
                    values={getTimeUpToNow()} type={"dropdown"}
                    onSelect={(value: any) => {
                        if (value?.length > 0) {
                            let form = props.formData;
                            form.startTime = concatenateDateTime({ date: props.formData.date.toDate(), time: value[0].value });
                            props.setFormData((previousData: any) => ({ ...previousData, ...form }));
                        }
                    }} />
            </div>
            <div className="input-field">
                <InputDropDown defaultValue={props.formData.endTime.format('hh:mm a')} title={"End Time"} values={getEndTime()}
                    type={"dropdown"}
                    onSelect={(value: any) => {
                        if (value?.length > 0) {
                            let form = props.formData;
                            form.endTime = concatenateDateTime({ date: props.formData.date.toDate(), time: value[0].value });
                            props.setFormData((previousData: any) => ({ ...previousData, ...form }));
                        }
                    }} />
            </div>
        </div>
    )
}

export default SelectTime